export default __webpack_public_path__ + "static/media/Action.e5bddc7b.svg";